export default {
  en: {
    title: "List of Contributors",
    intro: "The following individuals contributed to the development of this document:",
    summary: "The list of contributors to this work.",
    name: "Name",
    organization: "Organization",
    role: "Role"
  },
  es : {
    title: "Lista de Colaboradores",
    intro: "Las siguientes personas contribuyeron al desarrollo de este documento:",
    summary: "La lista de colaboradores de este trabajo.",
    name: "Nombre",
    organization: "Organización",
    role: "Rol"
  },
  ca : {
    title: "Llista de Col&middot;laboradors",
    intro: "Les persones següents van contribuir al desenvolupament d'aquest treball:",
    summary: "La llista de col&middot;laboradors d'aquest treball.",
    name: "Nomb",
    organization: "Organització",
    role: "Rol"
  }
};
